<template>
  <div>
    <v-menu
      v-model="filterMenu"
      :close-on-content-click="false"
      :nudge-right="8"
      :nudge-bottom="8"
      :max-height="$vuetify.breakpoint.height <= 750 ? $vuetify.breakpoint.height - 50 : 'auto'"
      offset-y
      bottom
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="$vuetify.breakpoint.width >= 450"
          text
          :color="filterMenu === true ? 'primary' : 'black'"
          v-on="on"
        >
          <v-icon class="mr-2">tune</v-icon>ตัวกรอง
        </v-btn>
      </template>

      <FilterContent @filterChange="filterChange" :festival="festival" />
    </v-menu>

    <v-dialog>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="$vuetify.breakpoint.width < 450"
          icon
          :color="filterMenu === true ? 'primary' : 'black'"
          v-on="on"
        >
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <FilterContent @filterChange="filterChange" :festival="festival" />
    </v-dialog>
  </div>
</template>

<script>
import FilterContent from './FilterContent.vue';

export default {
  name: 'FilterMenu',
  components: { FilterContent },
  data: () => ({
    filterMenu: false,
    filterTab: 0,
    filterObj: '',
    //
    startDate: '',
    endDate: '',
    reportDate: '',
    reportTime: '',
    //
    provinceSelect: '',
    provinceItems: [],
    vehicleSelect: '',
    vehicleItems: []
  }),
  props: {
    festival: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    filterChange(value) {
      // console.log(value)
      this.$emit('filterChange', value);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.brightgrey-bg {
  background-color: var(--v-brightgrey-base);
}
</style>
